export const MONTH_INDICES = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11] as const;
export const WEEKDAY_INDICES = [0, 1, 2, 3, 4, 5, 6] as const;
export const WEEK_START_DAY = 1;
export const API_DATE_FORMAT = 'yyyy-MM-dd';

export const ONE_SECOND = 1000;
export const ONE_MINUTE = ONE_SECOND * 60;
